export const isEmptyValue = (value: unknown) => {
  // for false or 0 should not return true
  return value === undefined || value === null || value === "";
};
